import React from 'react';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryWrapper } from 'app/types';
import { useSnakeBar } from '../../useSnakeBar';
import type { UsageInvoicingInsurer } from '../../../Domain/Admin/Services';
import { adminServices } from '../../../Domain/Admin/Services';

const queryFn = async () => {
  const response = await adminServices.getUsageInvoicingInsurers();
  return response.data;
};

const QUERY_KEY = 'getUsageInvoicingInsurers';

export const useUsageInvoicingInsurersQuery: UseQueryWrapper<UsageInvoicingInsurer[], undefined, false> = ({
  options,
} = {}) => {
  const { showErrorSnakeBar } = useSnakeBar();

  const onError = React.useCallback(() => {
    showErrorSnakeBar({ method: QUERY_KEY });
  }, [showErrorSnakeBar]);

  return useQuery<UsageInvoicingInsurer[]>([QUERY_KEY], queryFn, {
    onError,
    ...(options || {}),
  });
};
